import React, { useEffect, useState } from 'react'
import moment from 'moment'

import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk'
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled'

import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

import API from '../../../services/API'

const getName = (employee) =>
  `${employee?.firstName ?? ''} ${employee?.lastName ?? ''}`.trim()

const OnCallCard = () => {
  const [entries, setEntries] = useState([])

  useEffect(() => {
    API.get('/on-call-now').then((res) => {
      if (res.status === 200) setEntries(res.data?.entries ?? [])
    })
  }, [])

  if (entries.length === 0) return null

  return (
    <Grid item xs={12}>
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          borderRadius: 2,
          border: '1.5px dashed',
          borderColor: 'warning.main',
        }}
      >
        <Stack gap={1.5}>
          <Stack direction="row" alignItems="center" gap={1}>
            <PhoneInTalkIcon color="warning" fontSize="small" />
            <Typography variant="title3">On Call Now</Typography>
          </Stack>
          <Stack gap={1}>
            {entries.map((entry) => {
              const callable = !!entry.callNumber

              return (
                <Stack
                  key={entry._id}
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={1}
                  flexWrap="wrap"
                  component={callable ? 'a' : 'div'}
                  href={callable ? `tel:${entry.callNumber}` : undefined}
                  sx={{
                    p: 1,
                    borderRadius: 1,
                    bgcolor: 'grey.50',
                    textDecoration: 'none',
                    color: 'inherit',
                    cursor: callable ? 'pointer' : 'default',
                    '&:hover': callable ? { bgcolor: 'grey.100' } : undefined,
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    gap={1}
                    minWidth={0}
                  >
                    <Avatar
                      src={entry.employee?.photograph}
                      sx={{ width: 34, height: 34 }}
                    />
                    <Stack minWidth={0}>
                      <Typography variant="body2" fontWeight={700} noWrap>
                        {getName(entry.employee)}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        noWrap
                      >
                        {[
                          entry.baseLocationName,
                          entry.rosterTitle,
                          entry.clinicalRole,
                        ]
                          .filter(Boolean)
                          .join(' • ')}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack direction="row" alignItems="center" gap={1}>
                    {entry.onSiteLine && (
                      <Chip
                        size="small"
                        variant="outlined"
                        color="warning"
                        label="Site line"
                        sx={{ borderRadius: 1 }}
                      />
                    )}
                    <Chip
                      size="small"
                      variant="outlined"
                      label={`Until ${moment(entry.end).format('HH:mm')}`}
                      sx={{ borderRadius: 1 }}
                    />
                    <Tooltip
                      title={callable ? 'Tap to call' : 'No number on file'}
                    >
                      {callable ? (
                        <PhoneInTalkIcon color="warning" fontSize="small" />
                      ) : (
                        <PhoneDisabledIcon
                          color="disabled"
                          fontSize="small"
                        />
                      )}
                    </Tooltip>
                  </Stack>
                </Stack>
              )
            })}
          </Stack>
        </Stack>
      </Paper>
    </Grid>
  )
}

export default OnCallCard
